import ViewDataCertifications from './ViewDataCertifications';
import ViewDataVerifications from './ViewDataVerifications';
import { VerificationTypesEnum } from '@/lib/enum';
import { PanelInfo } from '@/components/custom';
import { getTitleEnumValue } from '@/functions';
import ViewDataUsers from './ViewDataUsers';
import { useUrlParams } from '../../hooks';
import { X } from 'lucide-react';

const ViewData = () => {

	const { tab, type } = useUrlParams();

	if (tab === 'verifiers' && type === VerificationTypesEnum.PROFILE_PHOTO) {
		return <ViewDataVerifications />;
	}

	if (tab === 'verifiers' && type === VerificationTypesEnum.IDENTITY) {
		return <ViewDataCertifications />;
	}

	if (tab === 'users') {
		return <ViewDataUsers />;
	}

	if (tab && !type) {
		return (
			<PanelInfo
				title='Paramètre invalide'
				description={
					<p className='flex space-x-1'>
						<span>
							Vous devez sélectionner un type de vérifications.
						</span>
					</p>
				}
				className='py-10 md:py-26 border-none'
				icon={X} />
		);
	}

	return (
		<PanelInfo
			title='Paramètre invalide'
			description={
				<p className='flex space-x-1'>
					<span>
						Aucune intégration n'est prévu pour le paramètre
					</span>
					<span className='text-purple-600'>
						{tab}
					</span>,
					<span className='text-purple-600'>
						{getTitleEnumValue('VerificationTypesEnum', type!)}
					</span>.
				</p>
			}
			className='py-10 md:py-26 border-none'
			icon={X} />
	);

};

export default ViewData;
